// extracted by mini-css-extract-plugin
module.exports = {"task-list-wrapper":"styles_task-list-wrapper__G3ryx"};